import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, Parallax, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/parallax";

import "../Sliders/Slide.css";

const Slide = () => {

  const [slideData, setSlideData] = useState([]);

  useEffect(() => {
    loadSlides();
  }, []);

  const loadSlides = async () => {

    try {

      const res = await axios.get("/api/sliders");

      /* SHOW ONLY ACTIVE SLIDES */

      const activeSlides = res.data.filter(slide => slide.status === 1);

      setSlideData(activeSlides);

    } catch (error) {

      console.error("Error loading sliders:", error);

    }

  };

  return(

  <Swiper
    key={slideData.length} // ? forces Swiper to re-init when slides load
    modules={[Navigation, Pagination, Autoplay, Parallax, EffectFade]}
    pagination={{ clickable: true }}
    autoplay={{
      delay: 9000,
      disableOnInteraction: false
    }}
    speed={1200}
    parallax={true}
    loop={true}
    effect="fade"
    className="slide-container"
  >

  {slideData.map((slide) => (

  <SwiperSlide key={slide.id}>

  <div className="slide">

  {/* IMAGE BACKGROUND */}

  {slide.type === "image" && (

  <div
    className="slide-bg"
    style={{
      backgroundImage: `url(${BASE_URL}/uploads/images/${slide.media})`
    }}
    data-swiper-parallax="-200"
  />

  )}

  {/* VIDEO BACKGROUND */}

  {slide.type === "video" && (

  <video
    className="slide-video"
    autoPlay
    loop
    muted
    playsInline
  >

  <source
    src={`${BASE_URL}/uploads/videos/${slide.media}`}
    type="video/mp4"
  />

  </video>

  )}

  {/* CONTENT */}

  <div className="slide-content">

  <h1 className="slide-title">

  {slide.title}

  </h1>

  <p className="slide-desc">

  {slide.description}

  </p>

  {/* BUTTON ONLY IF TEXT EXISTS */}

  {slide.button_text && (

  <a
    href={slide.button_link || "#"}
    className="slidebtn"
  >

  {slide.button_text}

  <i className="bi bi-arrow-right"></i>

  </a>

  )}

  </div>

  </div>

  </SwiperSlide>

  ))}

  </Swiper>

  );

};

export default Slide;